/* eslint-disable react-hooks/rules-of-hooks */

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SOCKET_EVENT } from "../data/socket.enum";
import { useRecord } from "../customHook/useRecord";
import { useRoomConnection } from "../customHook/useRoomConnection";
import { setCheck } from "../store/actions/userStateAction";

export const receiveStatus = () => {
  const dispatch = useDispatch();
  const { stopRecordHandler } = useRecord();

  const { socket } = useRoomConnection();
  //   const { pendingModal, disconnectMobileModal } = useSelector(
  //     (state) => state.modalAction,
  //   );

  //퇴장, 강제 퇴장
  //   useEffect(() => {
  //     if (Object.keys(socket).length === 0) return;
  //     socket?.on(SOCKET_EVENT.USER_WAITING, (message) => {
  //       if (message === "Y") {
  //         //퇴장 대기 상태 waiting
  //         dispatch({ type: WAITING_MODAL, data: "waiting" });
  //       } else {
  //         dispatch({ type: WAITING_MODAL, data: false });
  //       }
  //     });

  //     socket?.on(SOCKET_EVENT.USER_KICK, (message) => {
  //       dispatch({
  //         type: KICK_MODAL_ON,
  //         msg: message,
  //       });
  //       dispatch({ type: TIME_STOP, data: true });
  //       stopRecordHandler();
  //     });

  //     return () => {
  //       socket.off(SOCKET_EVENT.USER_KICK);
  //       socket.off(SOCKET_EVENT.USER_WAITING);
  //     };
  //   }, []);

  //감독관 일시정지 재생 펜딩
  useEffect(() => {
    if (Object.keys(socket).length === 0) return;
    socket?.on(SOCKET_EVENT.USER_EXAM, (message) => {
      if (message === "PAUSE") {
        dispatch(setCheck(false));
      } else if (message === "PLAY") {
        dispatch(setCheck(true));
      }
    });

    return () => {
      socket.off(SOCKET_EVENT.USER_EXAM);
    };
  }, []);
};
